module.exports = __webpack_public_path__ + "static/media/carpremium.ceb2761e.svg";